import React from 'react'
import {
    Button, Container,
    Row, Col, Label, Input
} from 'reactstrap'
import '../css/QuoteViewController.css'
import SimpleDropdown from '../view/DropDownView'
import DateTextField from '../view/DateTextField'
import { ContactInformationViewController } from './ContactInformationViewController'
import { AddressViewController } from './AddressViewController'
import {
    getQuote,
    updateQuote,
    getContactInfo,
} from '../model/request/quotes'
import { Quote } from '../model/Quote'
import { JustDate } from '../model/JustDate'

class BillingViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            'quote': null,
            'project_managers_options': [],
            'shipping_options': [],
            'invoicing_options': [],
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()

        getQuote(this.props.id).then(
            (result) => {
                const quote = Quote.from(result.data.quote)
                this.setState({
                    'quote': quote,
                })
                getContactInfo('customer_project_manager', quote.customer_name, '').then(
                    (result) => {
                        this.setState({
                            'project_managers_options': result.data.info.map((x) => x.customer_project_manager),
                            'shipping_options': result.data.info.map((x) => x.shipping_info),
                            'invoicing_options': result.data.info.map((x) => x.invoicing_contact_info),
                        })
                        this.props.turnOffLoader()
                    },
                    (error) => {
                        this.props.showError(error)
                        this.props.turnOffLoader()
                    }
                )
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    updateOptions(quoteField, thisStateField, value) {
        this.props.turnOnLoader()

        getContactInfo(
            quoteField,
            this.state.quote.customer_name,
            value,
        ).then(
            (result) => {
                this.setState({
                    thisStateField: result.data.info.map((x) => x[quoteField]),
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    // MARK: Button Actions

    saveModel() {
        const smaller_quote = ((
            {
                id,
                tracking_number,
                shipping_info,
                is_shipped,
                shipped_date,
                customer_project_manager,
                invoicing_contact_info,
                billing_comments,
                shipping_method,
            }
        ) => (
            {
                id,
                tracking_number,
                shipping_info,
                is_shipped,
                shipped_date,
                customer_project_manager,
                invoicing_contact_info,
                billing_comments,
                shipping_method,
            }
        ))(this.state.quote)

        this.props.turnOnLoader()
        updateQuote(smaller_quote).then(
            (result) => {
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    // MARK: View

    renderHeader(label) {
        return <Col>
            <Label style={{
                'fontSize': '20pt',
                'fontWeight': '500',
            }}>{label}</Label>
        </Col>
    }

    renderDropDown(value, values, onChange) {
        const updatedText = values.map((v) =>
            v == null ? "Empty" : v
        )
        if (values.indexOf(value) === -1) {
            updatedText.push(value)
        }
        updatedText.push('Other')
        return <SimpleDropdown
            index={updatedText.indexOf(value)}
            values={updatedText}
            onChange={(index) => {
                if (index === updatedText.length -1) {
                    this.props.showTextFieldModal('Project Manager', (value) => {
                        onChange(value, index)
                    })
                } else {
                    onChange(values[index], index)
                }
            }} />
    }

    renderLabelAndField(label, field) {
        return <>
            <Row
                style={{
                    'marginLeft': '30pt',
                }}
            >
                <Col>
                    <Label
                        style={{
                            'fontSize': '20pt',
                            'fontWeight': '400',
                        }}
                    >{label}</Label>
                </Col>
            </Row>
            <Row
                style={{
                    'marginLeft': '50pt',
                }}
            >
                <Col>{field}</Col>
            </Row>
        </>
    }

    render() {
        const trackingOptions = [
            'Fed Ex',
            'UPS',
        ]
        if (this.state.quote && this.state.quote.shipping_method &&
            !(trackingOptions.indexOf(this.state.quote.shipping_method) !== -1)) {
            trackingOptions.push(this.state.quote.shipping_method)
        }
        trackingOptions.push('Other')

        return (
            <Container>
                {this.props.breadCrumbs(4, this.props.id)}
                <Row>
                    { this.state.quote ?
                        <>
                        {this.renderHeader(this.state.quote.customer_name)}
                        {this.renderHeader(this.state.quote.job_name)}
                        {this.renderHeader(this.state.quote.given_id)}
                        </>
                        : <></>
                    }
                </Row>
                {this.state.quote ?
                <>
                    {this.renderLabelAndField(
                        "Tacking Method",
                        <SimpleDropdown
                            index={trackingOptions.indexOf(this.state.quote.shipping_method)}
                            values={trackingOptions}
                            onChange={(index) => {
                                if (index === trackingOptions.length -1) {
                                    this.props.showTextFieldModal('Project Manager', (value) => {
                                        const quote = this.state.quote
                                        quote.shipping_method = value
                                        this.setState({
                                            'quote': quote,
                                        })
                                    })
                                } else {
                                    const quote = this.state.quote
                                    quote.shipping_method = trackingOptions[index]
                                    this.setState({
                                        'quote': quote,
                                    })
                                }
                            }} />
                    )}
                {
                    this.renderLabelAndField(
                        "Shipped",
                        <>
                            <Input type='checkbox' checked={this.state.quote.is_shipped}
                                onClick={(e) => {
                                    const quote = this.state.quote
                                    const isBeingChecked = !quote.is_shipped
                                    quote.is_shipped = isBeingChecked
                                    quote.shipped_date = isBeingChecked ? new JustDate() : undefined
                                    this.setState({
                                        'quote': quote,
                                    })
                                }} />
                            <div style={{
                                    'display': 'inline-block',
                                    'width': 'min(600px, 100% - 22px)',
                                    'marginLeft': '8px',
                                    'maxWidth': '200px',
                                }}>
                                <DateTextField style={{
                                        'display': 'inline-block',
                                    }}
                                    value={
                                        // Quote.from() always turns shipped_date into a
                                        // JustDate, even when unset (null becomes the
                                        // 1970 epoch) - gate on is_shipped instead of
                                        // shipped_date's truthiness so an unshipped
                                        // quote shows blank rather than that epoch date.
                                        this.state.quote.is_shipped && this.state.quote.shipped_date ?
                                        this.state.quote.shipped_date :
                                        undefined
                                    }
                                    showModal={this.props.showModal}
                                    closeModal={this.props.closeModal}
                                    onChange={(date) => {
                                        const quote = this.state.quote
                                        quote.shipped_date = date
                                        this.setState({
                                            'quote': quote,
                                        })
                                    }} />
                            </div>
                        </>
                    )
                }
                {
                    this.renderLabelAndField(
                        "Tracking Numbers",
                        <>
                        {this.state.quote.tracking_number.map((trackingNumber, index) => {
                            return <Input
                                style={{
                                    'maxWidth': '300px',
                                }}
                                type="text"
                                value={trackingNumber}
                                onChange={(e) => {
                                    const trackingNumbers = this.state.quote.tracking_number
                                    trackingNumbers[index] = e.target.value
                                    this.setState({
                                        'quote': {
                                            ...this.state.quote,
                                            'tracking_number': trackingNumbers,
                                        }
                                    })
                                }}
                            />
                        })}
                        <Button
                            onClick={() => {
                                const quote = this.state.quote
                                quote.tracking_number.push('')
                                this.setState({
                                    'quote': quote,
                                })
                            }}
                        >Add Tracking Number</Button>
                        </>
                    )
                }
                <br />
                <Row>
                    <Col>
                        <Container style={{'maxWidth': '700px', 'marginLeft': '8px'}}>
                            {
                                this.state.quote == null ? <></> :
                                <AddressViewController
                                    model={this.state.quote.shipping_info}
                                    onUpdate={(fieldName, value) => {
                                        this.setState((state) => {
                                            state.quote.shipping_info[fieldName] = value
                                            return {
                                                'quote': state.quote,
                                            }
                                        })
                                    }} />
                            }
                        </Container>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <Container style={{'maxWidth': '700px', 'marginLeft': '8px', 'marginTop': '8px'}}>
                            <Row>
                                <Col>
                                    <Container>
                                        <Label style={{'fontSize': '20pt', 'fontWeight': '400'}}>
                                            Shipping Comments
                                        </Label>
                                    </Container>
                                </Col>
                            </Row>
                                <Col>
                                    <Container>
                                    {
                                        this.state.quote != null ?
                                            <Input
                                                type="textarea"
                                                value={this.state.quote.billing_comments}
                                                onChange={(e) => {
                                                    this.setState({
                                                        'quote': {
                                                            ...this.state.quote,
                                                            'billing_comments': e.target.value,
                                                        }
                                                    })
                                                }}
                                                style={{'width': '100%', 'height': '200px'}} />
                                            :
                                            <></>
                                    }
                                    </Container>
                                </Col>
                        </Container>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <Container style={{'maxWidth': '700px', 'marginLeft': '8px'}}>
                            {
                                this.state.quote == null ? <></> :
                                <ContactInformationViewController
                                    title={"Billing Contact Information"}
                                    model={this.state.quote.invoicing_contact_info}
                                    onUpdate={(fieldName, value) => {
                                        this.setState((state) => {
                                            state.quote.invoicing_contact_info[fieldName] =
                                                value
                                            return {
                                                'quote': state.quote,
                                            }
                                        })
                                        this.updateOptions(
                                            'invoicing_contact_info',
                                            'invoicing_options',
                                            value,
                                        )
                                    }}
                                    firstNames={
                                        this.state.invoicing_options
                                            .map((x) => x.first_name + ' ' + x.last_name)
                                    }
                                    onClickRow={(varName, value, index) => {
                                        this.setState((state) => {
                                            state.quote.invoicing_contact_info =
                                                this.state.invoicing_options[index]
                                            return {
                                                'quote': state.quote,
                                            }
                                        })
                                    }}
                                />
                            }
                        </Container>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <Container style={{'maxWidth': '700px', 'marginLeft': '8px'}}>
                            {
                                this.state.quote == null ? <></> :
                                <ContactInformationViewController
                                    title={"Project Manager Contact Information"}
                                    model={this.state.quote.customer_project_manager}
                                    onUpdate={(fieldName, value) => {
                                        this.setState((state) => {
                                            state.quote.customer_project_manager[fieldName] =
                                                value
                                            return {
                                                'quote': state.quote,
                                            }
                                        })
                                        this.updateOptions(
                                            'customer_project_manager',
                                            'project_managers_options',
                                            value,
                                        )
                                    }}
                                    firstNames={
                                        this.state.project_managers_options
                                            .map((x) => x.first_name + ' ' + x.last_name)
                                    }
                                    onClickRow={(varName, value, index) => {
                                        this.setState((state) => {
                                            state.quote.customer_project_manager =
                                                this.state.project_managers_options[index]
                                            return {
                                                'quote': state.quote,
                                            }
                                        })
                                    }}
                                />
                            }
                        </Container>
                    </Col>
                </Row>
                </>
                :<></>}
                <Row
                    className='quote-bottom-bottons-row'>
                    <Col>
                        <Container>
                            <Button color="success" onClick={(e) => this.saveModel()}
                                size="lg" className="default-weight purchase-button"
                                >Save</Button>
                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default BillingViewController

